import React from 'react';
import { Link } from 'react-router-dom';
import ToolInfoTable from '../components/tools/ToolInfoTable';
import CreatorInfo from '../components/common/CreatorInfo';

/**
 * ToolsPage Component
 * 
 * This page displays a list of available tools with their associated metadata.
 * It demonstrates the usage of the ToolInfoTable and CreatorInfo components.
 */
const ToolsPage = () => {
  // Example tool data
  const exampleTools = [
    {
      id: 1,
      title: "Competitor Analysis",
      slug: "competitor-analysis",
      description: "Understand the market landscape by analyzing competitors",
      category: "Investigate",
      updated: "10/08/20",
      creator: { text: "N/A" },
      templates: (
        <>
          <i className="far fa-file-pdf">&nbsp;&nbsp;</i>
          <a href="/empathise/investigate/competitor-analysis.pdf" className="link-table">PDF</a>&nbsp;&nbsp;
          <i className="fas fa-chalkboard"></i>&nbsp;&nbsp;
          <a href="https://miro.com/app/board/o9J_koh1sjE=/" className="link-table">Miro</a>
        </>
      )
    },
    {
      id: 2,
      title: "Research Canvas",
      slug: "research-canvas",
      description: "Structured approach to organizing research objectives and methods",
      category: "Investigate",
      updated: "20/08/20",
      creator: { href: "https://twitter.com/sniffles", text: "Stephanie Troeth" },
      templates: (
        <>
          <i className="far fa-file-pdf">&nbsp;&nbsp;</i>
          <a href="/empathise/investigate/research-canvas.pdf" className="link-table">PDF</a>&nbsp;&nbsp;
          <i className="fas fa-chalkboard"></i>&nbsp;&nbsp;
          <a href="https://miro.com/app/board/o9J_kois3So=/" className="link-table">Miro</a>
        </>
      )
    }
  ];

  return (
    <div className="tools-page container">
      <h1>Tools Library</h1>
      <p>Below are examples of various tools with their metadata displayed using the CreatorInfo and ToolInfoTable components.</p>
      
      {exampleTools.map(tool => (
        <div key={tool.id} className="tool-item">
          <h2 id={tool.slug}>{tool.title}</h2>
          
          <div className="tool-opening-container">
            <div className="tool-table-wrap">
              <ToolInfoTable toolInfo={tool} />
            </div>
            
            <div className="tool-opening">
              <p>{tool.description}</p>
              
              <h3>Creator Information Example</h3>
              <p>
                This tool was created by: <CreatorInfo creator={tool.creator} />
              </p>
            </div>
          </div>
          
          <div className="example-section">
            <h3>Various Ways to Use CreatorInfo</h3>
            <table id="tool-table">
              <tbody>
                <tr>
                  <th>Example Type</th>
                  <th>Rendered Component</th>
                </tr>
                <tr>
                  <td>String value</td>
                  <td><CreatorInfo creator="John Smith" /></td>
                </tr>
                <tr>
                  <td>Object with href and text</td>
                  <td><CreatorInfo creator={{ href: "https://example.com", text: "Example Link" }} /></td>
                </tr>
                <tr>
                  <td>Object with text only</td>
                  <td><CreatorInfo creator={{ text: "Text Only" }} /></td>
                </tr>
                <tr>
                  <td>No creator provided</td>
                  <td><CreatorInfo creator={null} /></td>
                </tr>
              </tbody>
            </table>
          </div>
        </div>
      ))}
    </div>
  );
};

export default ToolsPage; 